// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/create_cast.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionCastMember } from "./vision_cast_member_pb";
import { file_vision_shotlist_v1_vision_cast_member } from "./vision_cast_member_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/create_cast.proto.
 */
export const file_vision_shotlist_v1_create_cast: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvY3JlYXRlX2Nhc3QucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEikwEKEUNyZWF0ZUNhc3RSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuQ3JlYXRlQ2FzdFJlcXVlc3QuUGFyYW1zGjkKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSDQoFY29sb3IYAyABKAkinwEKEkNyZWF0ZUNhc3RSZXNwb25zZRJECgZyZXN1bHQYASABKAsyNC5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZUNhc3RSZXNwb25zZS5SZXN1bHQaQwoGUmVzdWx0EjkKBGNhc3QYASABKAsyKy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvbkNhc3RNZW1iZXJiBnByb3RvMw", [file_vision_shotlist_v1_vision_cast_member]);

/**
 * @generated from message protos.vision.shotlist.v1.CreateCastRequest
 */
export type CreateCastRequest = Message<"protos.vision.shotlist.v1.CreateCastRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreateCastRequest.Params params = 1;
   */
  params?: CreateCastRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateCastRequest.
 * Use `create(CreateCastRequestSchema)` to create a new message.
 */
export const CreateCastRequestSchema: GenMessage<CreateCastRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_cast, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreateCastRequest.Params
 */
export type CreateCastRequest_Params = Message<"protos.vision.shotlist.v1.CreateCastRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string color = 3;
   */
  color: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateCastRequest.Params.
 * Use `create(CreateCastRequest_ParamsSchema)` to create a new message.
 */
export const CreateCastRequest_ParamsSchema: GenMessage<CreateCastRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_cast, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreateCastResponse
 */
export type CreateCastResponse = Message<"protos.vision.shotlist.v1.CreateCastResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreateCastResponse.Result result = 1;
   */
  result?: CreateCastResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateCastResponse.
 * Use `create(CreateCastResponseSchema)` to create a new message.
 */
export const CreateCastResponseSchema: GenMessage<CreateCastResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_cast, 1);

/**
 * @generated from message protos.vision.shotlist.v1.CreateCastResponse.Result
 */
export type CreateCastResponse_Result = Message<"protos.vision.shotlist.v1.CreateCastResponse.Result"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.VisionCastMember cast = 1;
   */
  cast?: VisionCastMember | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateCastResponse.Result.
 * Use `create(CreateCastResponse_ResultSchema)` to create a new message.
 */
export const CreateCastResponse_ResultSchema: GenMessage<CreateCastResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_cast, 1, 0);

